import React from "react";
import { ButtonColors, ButtonSizes } from "./buttons.types";

const colorStyles: Record<string, string> = {
  black: "btnBase btnBlack",
  blue: "btnBase btnBlue",
  gray: "btnBase btnGray",
  "gray-and-yellow": "btnBase btnGrayAndYellow",
  green: "btnBase btnGreen",
  red: "btnBase btnRed",
  "white-outline": "btnBase btnWhiteOutline",
  yellow: "btnBase btnYellow",
  transparent: "btnBase btnTransparent",
};

const sizeStyles: Record<string, string> = {
  xs: "btnXs",
  sm: "btnSm",
  md: "btnMd",
  lg: "btnLg",
  xl: "btnXl",
};

const textSizes: Record<string, string> = {
  xs: "btnXsText",
  sm: "btnSmText",
  md: "btnMdText",
  lg: "btnLgText",
  xl: "btnXlText",
};

interface ButtonProps
  extends Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    "color" | "id" | "title"
  > {
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  color?: ButtonColors;
  dataTestid?: string;
  id?: number | string | null;
  size?: ButtonSizes;
  title?: string;
  tooltip?: string;
}

export default function Button({
  buttonRef,
  children,
  className,
  color,
  disabled = false,
  form,
  onClick,
  style,
  size = ButtonSizes.MD,
  title,
  tooltip,
  type = "button",
  id,
  dataTestid,
  ...buttonProps
}: ButtonProps) {
  const classNames = [
    className,
    colorStyles[color || ""],
    sizeStyles[size],
  ].filter(Boolean);

  return (
    <button
      {...buttonProps}
      ref={buttonRef}
      title={tooltip}
      className={classNames.join(" ")}
      disabled={disabled}
      form={form}
      onClick={onClick}
      style={style}
      type={type}
      id={id?.toString()}
      data-testid={dataTestid}
    >
      {children}
      {title ? <span className={textSizes[size] || ""}>{title}</span> : null}
    </button>
  );
}
